export default "/signup/_next/static/chunks/fonts/inter-v3-latin-600-c7c4151be11e84a79d3f2480fd905190.woff2";